import React, { useState } from 'react';
import { TextField, Button, Box, Grid, Select, InputLabel, MenuItem } from '@material-ui/core';
import { FormControl } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import useStyles  from './useStyles'

const PasoDosForm = () => {



    const classes = useStyles();
    const [value, setValue] = React.useState(new Date('2014-08-18T21:11:54'));

    const handleChange = (event) => {
        setAseguradora(event.target.value);
    };


    const [genero, setGenero] = React.useState('');
    const [aseguradora, setAseguradora] = React.useState('');
    const [subTitulo, setSubTitulo] = useState('Identificación del Representante') 
  

    return (


    <>
        {/* aca va el sub titulo del formulario */}
        <Box display="flex" justifyContent="start">
          <h3 style={{ color: '#0064AC', fontSize: 16, fontWeight: 'bold', marginLeft: 45 }}>{subTitulo}</h3>
        </Box>
        {/* cuerpo para inputs, puede ser mas de un grid dependiendo de las filas que se necesite */}
        <Grid>

          <FormControl className={classes.formControlComponent}>
            <TextField  onChange={() => { }} id="input-id" variant="outlined" label="Rut" size="small" />
          </FormControl>

          <FormControl className={classes.formControlComponent}>
            <TextField  onChange={() => { }} id="input-id" variant="outlined" label="Nombre" size="small" />
          </FormControl>

          <FormControl className={classes.formControlComponent}>
            <TextField  onChange={() => { }} id="input-id" variant="outlined" label="Apellido Paterno" size="small" />
          </FormControl>

          <FormControl className={classes.formControlComponent}>
            <TextField  onChange={() => { }} id="input-id" variant="outlined" label="Apellido Materno" size="small" />
          </FormControl>

          <FormControl className={classes.formControlComponent}>
            <TextField  onChange={() => { }} id="input-id" variant="outlined" label="Profesión u Oficio" size="small" />
          </FormControl>

        
        <FormControl className={classes.formControlComponent}>
          <TextField  onChange={() => { }} id="input-id" variant="outlined" label="Dirección"  size="small"/>
        </FormControl>


          <FormControl className={classes.formControlComponent}>
            <TextField  onChange={() => { }} id="input-id" variant="outlined" label="Telefono" size="small" />
          </FormControl>

          <FormControl className={classes.formControlComponent}>
            <TextField  onChange={() => { }} id="input-id" variant="outlined" label="Correo" size="small" />   
          </FormControl>

       <Box display="flex" justifyContent="start">
          <h3 style={{ color: '#0064AC', fontSize: 16, fontWeight: 'bold', marginLeft: 45 }}>Identificación Representante Isapre o Fonasa</h3>
        </Box>
        {/* cuerpo para inputs, puede ser mas de un grid dependiendo de las filas que se necesite */}
       

          <FormControl className={classes.formControlComponent}>
            <TextField  onChange={() => { }} id="input-id" variant="outlined" label="Rut" size="small" />
          </FormControl>

          <FormControl className={classes.formControlComponent}>
            <TextField  onChange={() => { }} id="input-id" variant="outlined" label="Nombre" size="small" />
          </FormControl>

          <FormControl className={classes.formControlComponent}>
            <TextField  onChange={() => { }} id="input-id" variant="outlined" label="Apellido Paterno" size="small" />
          </FormControl>

          <FormControl className={classes.formControlComponent}>
            <TextField  onChange={() => { }} id="input-id" variant="outlined" label="Apellido Materno" size="small" />
          </FormControl>

        
        <FormControl className={classes.formControlComponent}>
          <TextField  onChange={() => { }} id="input-id" variant="outlined" label="Dirección"  size="small"/>
        </FormControl>


          <FormControl className={classes.formControlComponent}>
            <TextField  onChange={() => { }} id="input-id" variant="outlined" label="Telefono" size="small" />
          </FormControl>

          <FormControl className={classes.formControlComponent}>
            <TextField  onChange={() => { }} id="input-id" variant="outlined" label="Correo" size="small" />   
          </FormControl>

          <FormControl className={classes.formControlComponent}></FormControl>




          </Grid>
      </>




  )
}

export default PasoDosForm